export default __webpack_public_path__ + "static/media/create-payment-link-button.41eaea72.png";